import { Heading1, Link, Paragraph } from "@sikt/sds-core";
import { GuidePanel } from "@sikt/sds-message";
import { Link as RouterLink } from "react-router-dom";
import styles from "./NotFoundNotice.module.css";

export function NotFoundNotice({ what }: { what: string }) {
  return (
    <div className={styles.box}>
      <Heading1 size="l">Fant ikke {what}</Heading1>
      <GuidePanel variant="info">
        <Paragraph>
          Lenken kan være skrevet feil, eller så finnes ikke {what} lenger.
          Sjekk at du har kopiert hele lenken du fikk delt.
        </Paragraph>
      </GuidePanel>
      <Link asChild isNavigation>
        <RouterLink to="/">Til forsiden</RouterLink>
      </Link>
    </div>
  );
}
